// extracted by mini-css-extract-plugin
module.exports = {"SelectionMenu__icon":"SelectionMenu__icon__2cMOw"};